<template>
  <div>
    <el-select
      v-model="selectValue"
      :placeholder="placeholder"
      :size="size"
      filterable
      clearable
      remote
      :remote-method="remoteMethod"
      :loading="loading"
      @focus="handleFocus"
      @change="handleChange"
    >
      <el-option
        v-for="op in selectData"
        :key="op[0]"
        :value="op[valueIndex]"
        :label="op[labelIndex]"
      >
        <span v-html="hightlight(op[labelIndex])"></span>
      </el-option>
    </el-select>
  </div>
</template>
<script>
  import util from '../../libs/util'
  export default {
    name: 'whaty-select',
    props: {
      value: {
        required: true
      },
      size: {
        type: String,
        default: 'mini'
      },
      placeholder: {
        type: String
      },
      url: String,
      queryParams: {
        type: Object,
        default() {
          return {}
        }
      },
      valueIndex: {
        type: Number,
        default: 0
      },
      labelIndex: {
        type: Number,
        default: 1
      }
    },
    data() {
      return {
        selectValue: '',
        selectData: [],
        loading: false,
        query: ''
      }
    },
    created() {
      this.selectValue = this.value
    },
    methods: {
      remoteMethod(query) {
        if (query && query.trim()) {
          this.query = query.trim()
          this.loading = true
          let params = this.queryParams
          params.query = this.query
          util.ajax.post(this.url, {params}).then((res) => {
            if (res.data.meta.errCode === 0) {
              this.selectData = res.data.data
              this.$emit('select-data-change', this.selectData)
            }
            this.loading = false
          }).catch((err) => {
            this.loading = false
            console.warn('获取下拉框数据失败: ' + params)
            console.error(err)
          })
        } else {
          this.selectData = []
          this.$emit('select-data-change', this.selectData)
        }
      },
      handleFocus() {
        if (!this.selectValue || !this.selectValue.trim()) {
          this.selectData = []
          this.$emit('select-data-change', this.selectData)
        }
      },
      handleChange(val) {
        this.selectValue = val
        this.$emit('input', val)
        this.$emit('change', val)
      },
      hightlight(value) { // 搜索关键字高亮
        return value.replace(this.query, '<b class="highlight">' + this.query + '</b>')
      }
    },
    watch: {
      value: function (newValue) {
        this.selectValue = newValue
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/whaty-select/whaty-select.vue